import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * メールアドレス
 */
export class Email extends PrimitiveValueObject<string> {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Email {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new Email(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return 'メールアドレス';
  }

  /**
   * プレースホルダー
   */
  static get placeholder(): string {
    return 'yamada@wagako.com';
  }

  /**
   * タイプ
   */
  static get type() {
    return 'text';
  }

  /**
   * キー
   */
  static get key() {
    return 'email';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      /** パターン */
      pattern: {
        /** 値 */
        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        /** メッセージ */
        message: 'メールアドレスの形式が不正です',
      },
    };
  }
}
